module.exports = __webpack_public_path__ + "img/image4.0c16063f.jpg";